import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import ProjectCard from "./ProjectCards";
import Particle from "../Particle";
import './index.css';
import {projects} from "../../Constants/index.js"
function Projects() {
	return (
		<Container fluid className="project-section">
			<Particle />
			<Container>
			<div className="parent-container">

		 {projects.map((project, index) => (
            <ProjectCard key={`project-${index}`} index={index} {...project} />
        ))}
		</div>
		</Container>
		</Container>
	);
}
export default Projects;
